import { render } from "./Top.vue?vue&type=template&id=50895e07"
const script = {}

import "./Top.vue?vue&type=style&index=0&id=50895e07&lang=css"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__